import GoogleLogin from 'core/components/GoogleLogin'
import useCommitThirdPartyLogin from 'core/hooks/useCommitThirdPartyLogin'
import { googleClientId, googleChannel } from '@/config'
import notification from '@/components/notification'
import { useLocale } from 'core/components/Locale'
import { useRef } from 'react'

export default function GoogleLoginPC(props: { className?: string; children: React.ReactNode; onSuccess: () => void }) {
  const t = useLocale()
  const thirdLoginResponseRef = useRef({})
  const commitThirdPartyLogin = useCommitThirdPartyLogin({
    onSuccess: (res) => {
      if (!res.data.data?.verifyResult) {
        notification.error({
          message: t('third_login_034'),
        })
        return
      }
      // todo: 登录成功后是否需要notification提示
      props.onSuccess(res, thirdLoginResponseRef.current)
    },
    onError: (error) => {
      console.log('google login error', error)
    },
  })
  return (
    <GoogleLogin
      clientId={googleClientId}
      handleCredentialResponse={(data) => {
        console.log('google login', data)
        thirdLoginResponseRef.current = data
        commitThirdPartyLogin('google', googleChannel, data)
        // 传给vue pc
        sessionStorage.setItem('thirdLoginOriginalAuthInfo', JSON.stringify(data))
      }}
      className={props.className}
    >
      {props.children}
    </GoogleLogin>
  )
}
